import ReactDOM from 'react-dom';
import { useState, useEffect, } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";

import CustomActionButton from "../../../common/CustomActionButton";
import CustomSliderModalV2 from "../../../common/CustomSliderModalV2";
import CustomButton from "../../../common/CustomButton";
import CustomSelect from "../../../common/CustomSelect";

import { SendEmail } from "../../../redux/brg/actions";
import { delay } from '../../../utils';

function FollowUpEmail(props) {
    const { patient, suggestedPrograms } = props;
    const emailTemplates = props?.EmailTemplate?.list;

    const [etOptions, setEtOptions] = useState([]);
    const [emailTemplate, setEmailTemplate] = useState(null);
    const [htmlPreview, setHtmlPreview] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [eventID, setEventID] = useState(null);

    useEffect(() => {
        if (emailTemplates?.length > 0) {
            const defaultET = emailTemplates?.filter((et) => (et?.tag == "post-discharge-reminder" && et?.is_default == 1))?.[0]
            setEmailTemplate(defaultET || null);

            const tempETO = [defaultET, ...emailTemplates.filter((et) => (et?.tag == "post-discharge-reminder" && et?.is_default == 0))];
            setEtOptions(tempETO.map((et) => {
                return {
                    value: et?.id,
                    label: et?.name.toUpperCase(),
                }
            }));

            handlePreviewEmail();

        }


    }, [emailTemplates?.length]);


    const arrangeHTMLContent = (htmlTemplate, patient, eventID, sp) => {
        const sentEmailLog = patient?.emailSentLogs[patient?.emailSentLogs.length - 1]
        const generatedEmail = patient?.generatedEmails.filter(ge => ge?.id == sentEmailLog?.email)?.[0];
        const emailContent = JSON.parse(generatedEmail?.email_content);
        const imgURL = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV) + "images/program-icons/";

        let htmlContent = htmlTemplate;

        htmlContent = htmlContent.replace("{{patient_name}}", (patient?.first_name));
        htmlContent = htmlContent.replace("{{signup_link}}", `${"https://indimoves.com/brg/"}?type=brgpatient&id=${generatedEmail?.id}&event_id=${eventID}&env=${process.env.REACT_APP_ENVIRONMENT}`);

        htmlContent = htmlContent.replace("{{program_image_1}}", imgURL + sp[0]?.svg?.split(".")[0] + ".png");
        htmlContent = htmlContent.replace("{{program_name1}}", emailContent?.suggested_programs[0]?.program_name);
        htmlContent = htmlContent.replace("{{program_description1}}", emailContent?.suggested_programs[0]?.program_description);

        htmlContent = htmlContent.replace("{{program_image_2}}", imgURL + sp[1]?.svg?.split(".")[0] + ".png");
        htmlContent = htmlContent.replace("{{program_name2}}", emailContent?.suggested_programs[1]?.program_name);
        htmlContent = htmlContent.replace("{{program_description2}}", emailContent?.suggested_programs[1]?.program_description);

        htmlContent = htmlContent.replace("{{program_image_3}}", imgURL + sp[2]?.svg?.split(".")[0] + ".png");
        htmlContent = htmlContent.replace("{{program_name3}}", emailContent?.suggested_programs[2]?.program_name);
        htmlContent = htmlContent.replace("{{program_description3}}", emailContent?.suggested_programs[2]?.program_description);


        return htmlContent;
    }

    const handlePreviewEmail = async (et = null) => {
        et = et || emailTemplate;
        const toastID = toast.loading("Generating Email Preview...");
        const tempEventID = new Date().getTime();

        setEventID(eID => tempEventID);
        setHtmlPreview(arrangeHTMLContent(et?.html_content, patient, tempEventID, suggestedPrograms));

        toast.dismiss(toastID);
        setShowModal(true);
    }

    const handleSendEmail = async () => {
        const toastID = toast.loading("Sending Email...");
        const sentEmailLog = patient?.emailSentLogs[patient?.emailSentLogs.length - 1]
        const generatedEmail = patient?.generatedEmails.filter(ge => ge?.id == sentEmailLog?.email)?.[0];

        let subject = emailTemplate?.email_subject;
        if (emailTemplate?.email_subject != "ai_generated") {
            subject = subject.replace("{{patient_name}}", patient?.first_name);
        }

        const res = await props.SendEmail(patient, generatedEmail, htmlPreview, subject, eventID, emailTemplate);

        if (res) {
            toast.success("Email Sent Successfully", {
                id: toastID,
            });
            delay(() => {
                setShowModal(false);
            }, 1500)
        } else {
            toast.error("Failed to Send Email", {
                id: toastID,
            });
        }
    }

    return (
        <>
            <div id="ep-cs-template">
                <CustomSelect placeholder={"Template"} options={etOptions} onChange={(e) => {
                    const et = emailTemplates?.filter((et) => et?.id == e.target.value)?.[0];
                    setEmailTemplate(et);
                    handlePreviewEmail(et);
                }} />
            </div>

            <div className="preview" dangerouslySetInnerHTML={{ __html: htmlPreview }} />
            <div className="flex-r pt-5 pb-5">
                <CustomActionButton action={() => {
                    handleSendEmail();
                }}>
                    SEND EMAIL
                </CustomActionButton>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    EmailTemplate: state.EmailTemplate,
})

export default connect(mapStateToProps, {
    SendEmail,
})(FollowUpEmail);
